import React, { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import FucaScoreLogo from "../../Assets/Images/fucascore_png.png";

const removeYear = (naziv) => {
  return naziv.replace(/\b(20\d{2})\b/g, "").trim();
};

const Navigation = ({
  setActiveTab,
  setSelectedGroup,
  turnirSlug: propTurnirSlug = "",
  turnirNaziv = "",
  turnirLogo = "",
  lokacija = "",
  nazivLokacije = "",
  features = {}, // Ovdje primamo cijeli features objekt iz baze
}) => {
  const navigate = useNavigate();
  const { turnirSlug: paramTurnirSlug } = useParams();
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const currentSlug = propTurnirSlug || paramTurnirSlug;

  const homePath = currentSlug ? `/${currentSlug}` : "/";
  const belaPath = currentSlug ? `/${currentSlug}/bela-turnir` : "/bela-turnir";
  const nogotenisPath = currentSlug
    ? `/${currentSlug}/nogotenis-turnir`
    : "/nogotenis-turnir";
  const nagradePath = currentSlug ? `/${currentSlug}/nagrade` : "/nagrade";
  const sponzoriPath = currentSlug ? `/${currentSlug}/sponzori` : "/sponzori";
  const dogadajiPath = currentSlug ? `/${currentSlug}/dogadaji` : "/dogadaji";

  const handleNavClick = (path) => {
    navigate(path);
    setIsMenuOpen(false);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const prikaziBelu = features?.beli !== false;
  const prikaziNogotenis = features?.nogotenis !== false; //

  return (
    <header className="header">
      <div className={`full-menu ${isMenuOpen ? "open" : ""}`}>
        <ul className="menu-links">
          <img
            src={turnirLogo || FucaScoreLogo}
            alt={turnirNaziv || "Turnir"}
            onClick={() => handleNavClick(homePath)}
            style={{ cursor: "pointer" }}
          />
          <li onClick={() => handleNavClick(homePath)}>Naslovna</li>

          {/* Prikazuje 'Bela turnir' samo ako je omogućeno */}
          {prikaziBelu && (
            <li onClick={() => handleNavClick(belaPath)}>Bela turnir</li>
          )}

          {/* Prikazuje 'Nogotenis turnir' samo ako je omogućeno u features */}
          {prikaziNogotenis && (
            <li onClick={() => handleNavClick(nogotenisPath)}>
              Nogotenis turnir
            </li>
          )}

          <li onClick={() => handleNavClick(nagradePath)}>Nagrade</li>
          <li onClick={() => handleNavClick(sponzoriPath)}>Sponzori</li>
          <li onClick={() => handleNavClick(dogadajiPath)}>Ostali događaji</li>
          <div className="social-medias">
            <a
              href="https://www.instagram.com/fucascore/"
              target="_blank"
              rel="noreferrer"
            >
              <i className="fi fi-brands-instagram"></i>
            </a>
          </div>
        </ul>
      </div>

      <nav className="navbar">
        <div onClick={() => handleNavClick("/")} style={{ cursor: "pointer" }}>
          <img className="logo" src={FucaScoreLogo} alt="FucaScore Logo" />
        </div>

        <div className="center-section">
          <span className="text-title">{removeYear(turnirNaziv)}</span>
        </div>

        <div className="actions">
          <div
            className={isMenuOpen ? "hamburger active" : "hamburger"}
            onClick={() => setIsMenuOpen(!isMenuOpen)}
          >
            <span className="bar"></span>
            <span className="bar"></span>
            <span className="bar"></span>
          </div>
        </div>
      </nav>

      <a
        href={lokacija || "#"}
        target="_blank"
        rel="noreferrer"
        className="location-bar"
      >
        <i className="fi fi-rs-marker"></i>
        <span>{nazivLokacije || "Lokacija"}</span>
      </a>
    </header>
  );
};

export default Navigation;
